import styled from 'styled-components'

export const ModalBackPrompt = styled.div`
  max-width: 550px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  p {
    width: 100%;
  }

  i.fa-sign-out {
    transform: scaleX(-1);
    margin-right: 10px;
  }
`

export const ArticleSubstitutionsList = styled.ul`
  width: 100%;
  list-style: none;
  margin: 0 0 20px;
  padding: 0;

  li {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
    padding: 8px 0;
    border-bottom: 1px solid #ddd;
  }

  li span {
    flex: 1 1 200px;
  }
`
